import api from './api';

export async function verificaModuloHabilitado(chaveModulo) {
  const response = await api.get(`Modulo/habilitado/${chaveModulo}`);

  return response.status === 200;
}
